
// import React, { useState, useEffect } from "react";
// import {
//   FileText,
//   Download,
//   CheckCircle,
//   XCircle,
//   AlertCircle,
// } from "lucide-react";

// const TransactionReportGenerator = () => {
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [format, setFormat] = useState("PDF");
//   const [transactionTypes, setTransactionTypes] = useState([]);
//   const [status, setStatus] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [reportData, setReportData] = useState(null);
//   const [showGenerator, setShowGenerator] = useState(false);

//   // API base URL
//   const API_BASE_URL = "http://localhost:5000/api/v1";

//   // Format options for the report
//   const formatOptions = [
//     { value: "PDF", label: "PDF Document" },
//     { value: "EXCEL", label: "Excel Spreadsheet" },
//     { value: "CSV", label: "CSV File" }
//   ];

//   // Transaction type options
//   const transactionTypeOptions = [
//     { value: "DEPOSIT", label: "Deposit" },
//     { value: "WITHDRAWAL", label: "Withdrawal" },
//     { value: "TRANSFER", label: "Transfer" },
//     { value: "REFUND", label: "Refund" },
//     { value: "FEE", label: "Fee" }
//   ];

//   // Status options
//   const statusOptions = [
//     { value: "", label: "All Statuses" },
//     { value: "COMPLETED", label: "Completed" },
//     { value: "PENDING", label: "Pending" },
//     { value: "FAILED", label: "Failed" },
//     { value: "CANCELLED", label: "Cancelled" }
//   ];

//   // Reset error when form inputs change
//   useEffect(() => {
//     setError(null);
//   }, [startDate, endDate, format, transactionTypes, status]);

//   const getAuthHeader = () => ({
//     Authorization: `Bearer ${
//       localStorage.getItem("authToken") || "your-token-here"
//     }`
//   });

//   const handleTypeChange = (e) => {
//     const { value, checked } = e.target;
//     if (checked) {
//       setTransactionTypes([...transactionTypes, value]);
//     } else {
//       setTransactionTypes(transactionTypes.filter(type => type !== value));
//     }
//   };

//   const handleGenerateReport = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);

//     try {
//       // Validate dates
//       if (!startDate || !endDate) {
//         throw new Error("Start date and end date are required");
//       }

//       if (new Date(startDate) > new Date(endDate)) {
//         throw new Error("Start date cannot be after end date");
//       }

//       // Call API to generate report
//       const response = await window.fetch(
//         `${API_BASE_URL}/reports/admin/users/transaction-report`,
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             ...getAuthHeader()
//           },
//           body: JSON.stringify({
//             startDate,
//             endDate,
//             format,
//             transactionTypes: transactionTypes.length > 0 ? transactionTypes : undefined,
//             status: status || undefined
//           })
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to generate report");
//       }

//       const responseData = await response.json();

//       // Set the report data with completed status for demo purposes
//       setReportData({
//         ...responseData.data,
//         status: "COMPLETED"
//       });

//     } catch (err) {
//       setError(err.message || "Failed to generate report");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDownload = async () => {
//     if (reportData?.reportId && reportData?.status === "COMPLETED") {
//       try {
//         setLoading(true);

//         // Get the download URL
//         const downloadUrl = `${API_BASE_URL}/reports/admin/reports/${reportData.reportId}/download`;
//         const token = localStorage.getItem("authToken") || "your-token-here";

//         // Fetch the file directly as a blob to preserve binary data integrity
//         const response = await fetch(downloadUrl, {
//           method: 'GET',
//           headers: {
//             'Authorization': `Bearer ${token}`
//           }
//         });

//         if (!response.ok) {
//           throw new Error(`Download failed with status: ${response.status}`);
//         }

//         // Get the content type and disposition from headers
//         const contentType = response.headers.get('content-type');
//         const contentDisposition = response.headers.get('content-disposition');

//         // Set proper file extension based on actual content type
//         let filename;

//         // Try to get filename from Content-Disposition header
//         if (contentDisposition) {
//           const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
//           if (filenameMatch && filenameMatch[1]) {
//             // Clean the filename string from quotes if present
//             filename = filenameMatch[1].replace(/['"]/g, '');
//           }
//         }

//         // Use format-specific filename if not provided in headers
//         if (!filename) {
//           if (format === 'PDF') {
//             filename = 'transaction_report.pdf';
//           } else if (format === 'EXCEL') {
//             filename = 'transaction_report.xlsx';
//           } else {
//             filename = 'transaction_report.csv';
//           }
//         }

//         // Ensure correct file extension based on content type
//         if (contentType) {
//           if (contentType.includes('spreadsheetml') && !filename.endsWith('.xlsx')) {
//             filename = filename.replace(/\.[^/.]+$/, '') + '.xlsx';
//           } else if (contentType.includes('csv') && !filename.endsWith('.csv')) {
//             filename = filename.replace(/\.[^/.]+$/, '') + '.csv';
//           } else if (contentType.includes('pdf') && !filename.endsWith('.pdf')) {
//             filename = filename.replace(/\.[^/.]+$/, '') + '.pdf';
//           }
//         }

//         // Get the blob with the correct content type
//         const blob = await response.blob();

//         // Create an object URL for the blob
//         const url = URL.createObjectURL(blob);

//         // Create download link
//         const a = document.createElement('a');
//         a.href = url;
//         a.download = filename;
//         a.style.display = 'none';

//         // Append to body, trigger click, and clean up
//         document.body.appendChild(a);
//         a.click();

//         // Clean up
//         setTimeout(() => {
//           document.body.removeChild(a);
//           URL.revokeObjectURL(url);
//         }, 100);

//       } catch (err) {
//         console.error("Download error:", err);
//         setError(`Download error: ${err.message}`);
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const getStatusIcon = (status) => {
//     switch (status) {
//       case "COMPLETED":
//         return <CheckCircle className="h-5 w-5 text-green-500" />;
//       case "FAILED":
//         return <XCircle className="h-5 w-5 text-red-500" />;
//       default:
//         return <AlertCircle className="h-5 w-5 text-gray-500" />;
//     }
//   };

//   const getStatusText = (status) => {
//     switch (status) {
//       case "COMPLETED":
//         return "Ready for download";
//       case "FAILED":
//         return "Failed";
//       default:
//         return "Unknown";
//     }
//   };

//   return (
//     <div className="mb-6">
//       {!showGenerator ? (
//         <button
//           onClick={() => setShowGenerator(true)}
//           className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
//         >
//           <FileText className="h-4 w-4 mr-2" />
//           Generate Transaction Report
//         </button>
//       ) : (
//         <div className="bg-white rounded-lg shadow p-6 mt-4">
//           <div className="flex justify-between items-center mb-4">
//             <h3 className="text-lg font-medium">Generate Transaction Report</h3>
//             <button
//               onClick={() => setShowGenerator(false)}
//               className="text-gray-500 hover:text-gray-700"
//             >
//               <XCircle className="h-5 w-5" />
//             </button>
//           </div>

//           <div className="space-y-4">
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div>
//                 <label
//                   htmlFor="startDate"
//                   className="block text-sm font-medium text-gray-700 mb-1"
//                 >
//                   Start Date
//                 </label>
//                 <input
//                   type="date"
//                   id="startDate"
//                   value={startDate}
//                   onChange={(e) => setStartDate(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
//                   required
//                 />
//               </div>

//               <div>
//                 <label
//                   htmlFor="endDate"
//                   className="block text-sm font-medium text-gray-700 mb-1"
//                 >
//                   End Date
//                 </label>
//                 <input
//                   type="date"
//                   id="endDate"
//                   value={endDate}
//                   onChange={(e) => setEndDate(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
//                   required
//                 />
//               </div>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div>
//                 <label
//                   htmlFor="format"
//                   className="block text-sm font-medium text-gray-700 mb-1"
//                 >
//                   Report Format
//                 </label>
//                 <select
//                   id="format"
//                   value={format}
//                   onChange={(e) => setFormat(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
//                 >
//                   {formatOptions.map((option) => (
//                     <option key={option.value} value={option.value}>
//                       {option.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div>
//                 <label
//                   htmlFor="status"
//                   className="block text-sm font-medium text-gray-700 mb-1"
//                 >
//                   Transaction Status
//                 </label>
//                 <select
//                   id="status"
//                   value={status}
//                   onChange={(e) => setStatus(e.target.value)}
//                   className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
//                 >
//                   {statusOptions.map((option) => (
//                     <option key={option.value} value={option.value}>
//                       {option.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Transaction Types
//               </label>
//               <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
//                 {transactionTypeOptions.map((option) => (
//                   <div key={option.value} className="flex items-center">
//                     <input
//                       type="checkbox"
//                       id={`type-${option.value}`}
//                       value={option.value}
//                       checked={transactionTypes.includes(option.value)}
//                       onChange={handleTypeChange}
//                       className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//                     />
//                     <label
//                       htmlFor={`type-${option.value}`}
//                       className="ml-2 text-sm text-gray-700"
//                     >
//                       {option.label}
//                     </label>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {error && (
//               <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md">
//                 {error}
//               </div>
//             )}

//             <div className="flex justify-between items-center">
//               <button
//                 onClick={handleGenerateReport}
//                 disabled={loading}
//                 className={`flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
//                   loading ? "opacity-70 cursor-not-allowed" : ""
//                 }`}
//               >
//                 {loading ? (
//                   <>
//                     <span className="animate-spin mr-2">⟳</span>
//                     Processing...
//                   </>
//                 ) : (
//                   <>
//                     <FileText className="h-4 w-4 mr-2" />
//                     Generate Report
//                   </>
//                 )}
//               </button>

//               {reportData && reportData.status && (
//                 <div className="flex items-center">
//                   {getStatusIcon(reportData.status)}
//                   <span className="ml-2 text-sm text-gray-600">
//                     {getStatusText(reportData.status)}
//                   </span>
//                 </div>
//               )}
//             </div>
//           </div>

//           {reportData && reportData.status === "COMPLETED" && (
//             <div className="mt-6 border-t border-gray-200 pt-4">
//               <div className="flex justify-between items-center">
//                 <div>
//                   <h4 className="font-medium">Report Ready</h4>
//                   <p className="text-sm text-gray-600">
//                     {format} report for all transactions from{" "}
//                     {new Date(startDate).toLocaleDateString()} to{" "}
//                     {new Date(endDate).toLocaleDateString()}
//                   </p>
//                 </div>
//                 <button
//                   onClick={handleDownload}
//                   disabled={loading}
//                   className={`flex items-center px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 ${
//                     loading ? "opacity-70 cursor-not-allowed" : ""
//                   }`}
//                 >
//                   {loading ? (
//                     <>
//                       <span className="animate-spin mr-2">⟳</span>
//                       Downloading...
//                     </>
//                   ) : (
//                     <>
//                       <Download className="h-4 w-4 mr-2" />
//                       Download
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default TransactionReportGenerator;



import React, { useState, useEffect } from "react";
import {
  FileText,
  Download,
  CheckCircle,
  XCircle,
  AlertCircle,
} from "lucide-react";
import TransactionService from "@/services/api/transaction.service";

const TransactionReportGenerator = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [format, setFormat] = useState("PDF");
  const [transactionTypes, setTransactionTypes] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [showGenerator, setShowGenerator] = useState(false);

  // API base URL
  const API_BASE_URL = "http://localhost:5000/api/v1";

  // Format options for the report
  const formatOptions = [
    { value: "PDF", label: "PDF Document" },
    { value: "EXCEL", label: "Excel Spreadsheet" },
    { value: "CSV", label: "CSV File" }
  ];

  // Transaction type options
  const transactionTypeOptions = [
    { value: "DEPOSIT", label: "Deposit" },
    { value: "WITHDRAWAL", label: "Withdrawal" },
    { value: "TRANSFER", label: "Transfer" },
    { value: "REFUND", label: "Refund" },
    { value: "FEE", label: "Fee" }
  ];

  // Status options
  const statusOptions = [
    { value: "", label: "All Statuses" },
    { value: "COMPLETED", label: "Completed" },
    { value: "PENDING", label: "Pending" },
    { value: "FAILED", label: "Failed" },
    { value: "CANCELLED", label: "Cancelled" }
  ];

  // Reset error when form inputs change
  useEffect(() => {
    setError(null);
  }, [startDate, endDate, format, transactionTypes, status]);

  const getAuthHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem("authToken") || "your-token-here"
      }`
  });

  const handleTypeChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setTransactionTypes([...transactionTypes, value]);
    } else {
      setTransactionTypes(transactionTypes.filter(type => type !== value));
    }
  };

  // ...existing code...



  const handleGenerateReport = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Validate dates
      if (!startDate || !endDate) {
        throw new Error("Start date and end date are required");
      }
      if (new Date(startDate) > new Date(endDate)) {
        throw new Error("Start date cannot be after end date");
      }

      // Use the service method
      const result = await TransactionService.generateReport({
        startDate,
        endDate,
        format,
        transactionTypes,
        status,
      });

      if (result.success) {
        // Extract the actual report info from the API response data
        const reportInfo = result.data.data || result.data;
        setReportData({
          ...reportInfo,
          // Use returned status or default to PROCESSING if new
          status: reportInfo.status || "PROCESSING",
        });
      } else {
        throw new Error(result.message || "Failed to generate report");
      }
    } catch (err) {
      setError(err.message || "Failed to generate report");
      setLoading(false); // Stop loading only on error, otherwise keep it true or manage separatel if polling
    } finally {
      // If immediate success, we might still be processing. 
      // We'll let the polling logic handle 'loading' state if needed, 
      // or just set loading false here and show status.
      setLoading(false);
    }
  };

  // Poll for status updates if report is in PROCESSING state
  useEffect(() => {
    let intervalId;

    if (reportData && reportData.status === "PROCESSING" && reportData.reportId) {
      // Start polling
      intervalId = setInterval(async () => {
        try {
          const statusResult = await TransactionService.getReportStatus(reportData.reportId);
          if (statusResult.success) {
            const updatedReport = statusResult.data.data || statusResult.data;

            // Update state if status changed
            if (updatedReport.status !== "PROCESSING") {
              setReportData(prev => ({
                ...prev,
                ...updatedReport,
                status: updatedReport.status
              }));
            }
          }
        } catch (err) {
          console.error("Error polling report status:", err);
          // Optionally stop polling on error or just retry
        }
      }, 3000); // Poll every 3 seconds
    }

    // Cleanup interval
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [reportData]); // Re-run effect when reportData changes (e.g. status updates)


  const handleDownload = async () => {
    if (reportData?.reportId && reportData?.status === "COMPLETED") {
      try {
        setLoading(true);

        // Use the service method (pass only reportId)
        const result = await TransactionService.downloadReport(reportData.reportId);

        if (!result.success) {
          throw new Error(result.error || "Download failed");
        }

        const blob = result.data;
        // Handle headers which might be directly on result if the service returned them there
        const headers = result.headers || {};
        const contentType = headers['content-type'] || headers['Content-Type'];
        const contentDisposition = headers['content-disposition'] || headers['Content-Disposition'];

        const filename = TransactionService.getDownloadFilename(
          contentDisposition,
          format,
          contentType
        );
        TransactionService.triggerFileDownload(blob, filename);
      } catch (err) {
        setError(`Download error: ${err.message}`);
      } finally {
        setLoading(false);
      }
    }
  };


  const getStatusIcon = (status) => {
    switch (status) {
      case "COMPLETED":
        return <CheckCircle className="h-5 w-5 text-green-500" />;
      case "PROCESSING":
        return <div className="animate-spin h-5 w-5 border-2 border-blue-500 rounded-full border-t-transparent"></div>;
      case "FAILED":
        return <XCircle className="h-5 w-5 text-red-500" />;
      default:
        return <AlertCircle className="h-5 w-5 text-gray-500" />;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "COMPLETED":
        return "Ready for download";
      case "PROCESSING":
        return "Generating report...";
      case "FAILED":
        return "Failed";
      default:
        return "Unknown";
    }
  };

  return (
    <div className="mb-6">
      {!showGenerator ? (
        <button
          onClick={() => setShowGenerator(true)}
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <FileText className="h-4 w-4 mr-2" />
          Generate Transaction Report
        </button>
      ) : (
        <div className="bg-white rounded-lg shadow p-6 mt-4">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-medium">Generate Transaction Report</h3>
            <button
              onClick={() => setShowGenerator(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              <XCircle className="h-5 w-5" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label
                  htmlFor="startDate"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Start Date
                </label>
                <input
                  type="date"
                  id="startDate"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="endDate"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  End Date
                </label>
                <input
                  type="date"
                  id="endDate"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label
                  htmlFor="format"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Report Format
                </label>
                <select
                  id="format"
                  value={format}
                  onChange={(e) => setFormat(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                >
                  {formatOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label
                  htmlFor="status"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Transaction Status
                </label>
                <select
                  id="status"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                >
                  {statusOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Transaction Types
              </label>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                {transactionTypeOptions.map((option) => (
                  <div key={option.value} className="flex items-center">
                    <input
                      type="checkbox"
                      id={`type-${option.value}`}
                      value={option.value}
                      checked={transactionTypes.includes(option.value)}
                      onChange={handleTypeChange}
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label
                      htmlFor={`type-${option.value}`}
                      className="ml-2 text-sm text-gray-700"
                    >
                      {option.label}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md">
                {error}
              </div>
            )}

            <div className="flex justify-between items-center">
              <button
                onClick={handleGenerateReport}
                disabled={loading}
                className={`flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 ${loading ? "opacity-70 cursor-not-allowed" : ""
                  }`}
              >
                {loading ? (
                  <>
                    <span className="animate-spin mr-2">⟳</span>
                    Processing...
                  </>
                ) : (
                  <>
                    <FileText className="h-4 w-4 mr-2" />
                    Generate Report
                  </>
                )}
              </button>

              {reportData && reportData.status && (
                <div className="flex items-center">
                  {getStatusIcon(reportData.status)}
                  <span className="ml-2 text-sm text-gray-600">
                    {getStatusText(reportData.status)}
                  </span>
                </div>
              )}
            </div>
          </div>

          {reportData && reportData.status === "COMPLETED" && (
            <div className="mt-6 border-t border-gray-200 pt-4">
              <div className="flex justify-between items-center">
                <div>
                  <h4 className="font-medium">Report Ready</h4>
                  <p className="text-sm text-gray-600">
                    {format} report for all transactions from{" "}
                    {new Date(startDate).toLocaleDateString()} to{" "}
                    {new Date(endDate).toLocaleDateString()}
                  </p>
                </div>
                <button
                  onClick={handleDownload}
                  disabled={loading}
                  className={`flex items-center px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 ${loading ? "opacity-70 cursor-not-allowed" : ""
                    }`}
                >
                  {loading ? (
                    <>
                      <span className="animate-spin mr-2">⟳</span>
                      Downloading...
                    </>
                  ) : (
                    <>
                      <Download className="h-4 w-4 mr-2" />
                      Download
                    </>
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TransactionReportGenerator;